<template lang="html">
  <div class="selectBox">
    <select>
      <option v-for="(item, k) in items"
              :key="k"
              :value="item.val"
              @click="$emit('val', item.val)">
        {{item.title}}
      </option>
    </select>
  </div>
</template>

<script>
  export default {
    props: {
      val: null,
      items: Array,
    },

    data() {
      return {}
    }
  }
</script>

<style lang="css" scoped>
  .v-application ul {
    padding-left: 0px;
  }
  
</style>

